/**
 * Invoice detail card showing customer info, dates, totals.
 * Extracted from InvoiceManager.
 */

import styles from './invoiceManagerStyles';

interface InvoiceRecord {
  status?: string;
  customer_name?: string;
  customer_email?: string;
  billing_address?: { address?: string };
  date?: string;
  due_date?: string;
  total?: number;
  [key: string]: unknown;
}

interface LocalInvoiceData {
  split_code?: string;
  [key: string]: unknown;
}

export interface InvoiceDetailCardProps {
  invoice: InvoiceRecord;
  localData: LocalInvoiceData | null;
  formatCurrency: (amount: number) => string;
  getStatusColor: (status: string) => string;
  onEditAddress: () => void;
}

export default function InvoiceDetailCard({
  invoice, localData, formatCurrency, getStatusColor, onEditAddress,
}: InvoiceDetailCardProps) {
  return (
    <div style={styles.card}>
      <div className="flex-between mb-md">
        <h2 style={styles.cardTitle}>Invoice Details</h2>
        <span style={{ ...styles.statusBadge, backgroundColor: getStatusColor(invoice.status ?? '') }}>
          {invoice.status?.toUpperCase()}
        </span>
      </div>

      <div className="grid gap-md" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))' }}>
        <div style={styles.detailGroup}>
          <span style={styles.detailLabel}>Customer</span>
          <span style={styles.detailValue}>{invoice.customer_name}</span>
        </div>
        <div style={styles.detailGroup}>
          <span style={styles.detailLabel}>Email</span>
          <span style={styles.detailValue}>{invoice.customer_email || '-'}</span>
        </div>
        <div style={styles.detailGroup}>
          <span style={styles.detailLabel}>Billing Address</span>
          <span style={styles.detailValue}>{invoice.billing_address?.address || 'Not set'}</span>
          <button onClick={onEditAddress} style={styles.smallBtn}>
            Edit Address
          </button>
        </div>
        <div style={styles.detailGroup}>
          <span style={styles.detailLabel}>Invoice Date</span>
          <span style={styles.detailValue}>{invoice.date}</span>
        </div>
        <div style={styles.detailGroup}>
          <span style={styles.detailLabel}>Due Date</span>
          <span style={styles.detailValue}>{invoice.due_date}</span>
        </div>
        <div style={styles.detailGroup}>
          <span style={styles.detailLabel}>Current Total</span>
          <span className="fw-bold" style={{ ...styles.detailValue, fontSize: 'var(--text-3xl)' }}>
            {formatCurrency(invoice.total ?? 0)}
          </span>
        </div>
        {localData?.split_code && (
          <div style={styles.detailGroup}>
            <span style={styles.detailLabel}>Split Code</span>
            <span style={styles.detailValue}>{localData.split_code}</span>
          </div>
        )}
      </div>
    </div>
  );
}
